'use strict';

var _classCallCheck = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var withIs = require('class-is');

var noop = function noop() {};

var Topology = /*#__PURE__*/function () {
  /**
   * @param {Object} props
   * @param {number} props.min minimum needed connections (default: 0)
   * @param {number} props.max maximum needed connections (default: Infinity)
   * @param {Object} [props.handlers]
   * @param {function} [props.handlers.onConnect] protocol "onConnect" handler
   * @param {function} [props.handlers.onDisconnect] protocol "onDisconnect" handler
   * @constructor
   */
  function Topology(_ref) {
    var _ref$min = _ref.min,
        min = _ref$min === void 0 ? 0 : _ref$min,
        _ref$max = _ref.max,
        max = _ref$max === void 0 ? Infinity : _ref$max,
        _ref$handlers = _ref.handlers,
        handlers = _ref$handlers === void 0 ? {} : _ref$handlers;

    _classCallCheck(this, Topology);

    this.min = min;
    this.max = max; // Handlers

    this._onConnect = handlers.onConnect || noop;
    this._onDisconnect = handlers.onDisconnect || noop;
    this.peers = new Map();
  }

  _createClass(Topology, [{
    key: "disconnect",

    /**
     * Notify about peer disconnected event.
     * @param {PeerInfo} peerInfo
     * @returns {void}
     */
    value: function disconnect(peerInfo) {
      this._onDisconnect(peerInfo);
    }
  }, {
    key: "registrar",
    set: function set(registrar) {
      this._registrar = registrar;
    }
  }]);

  return Topology;
}();

module.exports = withIs(Topology, {
  className: 'Topology',
  symbolName: '@libp2p/js-interfaces/topology'
});